module.exports = __webpack_public_path__ + "img/kimi-2.d714fdeb.png";